<template>
  <div>
    <slot />
  </div>
</template>

<script>
import { getApp } from '@/utils/util';

export default {
  name: 'LoginableDiv',
  created() {
    this.getUserInfo('created');
    this.observerProfileUpdated();
  },
  destroyed() {
    getApp().$off('updateUserInfo', this.receiveUserInfoUpdated);
  },
  methods: {
    getUserInfo(from) {
      this.tools.callNativeWithPromise('getUserInfo').then((userInfo) => {
        this.$emit('UserInfoChanged', {
          userInfo,
          isFromLogin: false,
          from,
        });
      }).catch((err) => {
        console.log('getUserInfo failed: ', err);
        this.$emit('UserInfoChanged', {
          userInfo: null,
          isFromLogin: false,
          from,
        });
      });
    },
    observerProfileUpdated() {
      getApp().$on('updateUserInfo', this.receiveUserInfoUpdated);
    },
    receiveUserInfoUpdated(userInfo) {
      this.$emit('UserInfoChanged', {
        userInfo,
        isFromLogin: true,
      });
    },
  },
};
</script>
